const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const apiUrl = `${baseUrl}/api`;
export const imageUrl = `${baseUrl}/api/images`;
export const adminsImageUrl = `${baseUrl}/api/admins/images`;
export const publicUrl = `${baseUrl}/public`;
